var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 260,
    height: 97.397,
    viewBox: "0 0 260 97.397",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_22",
    "data-name": "Grupo 22",
    transform: "translate(-217.101 -414.429)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_7",
    "data-name": "Elipse 7",
    cx: 14.031,
    cy: 14.031,
    r: 14.031,
    transform: "translate(449.04 414.429)",
    fill: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_19",
    "data-name": "Grupo 19",
    transform: "translate(217.101 429.693)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_23",
    "data-name": "Caminho 23",
    d: "M288.563,523.348a12.573,12.573,0,0,1-25.144.122c.007-.152.01-.3.01-.454v-.122a12.581,12.581,0,0,0-12.579-12.457,12.4,12.4,0,0,0-1.286.065c-.017,0-.031,0-.048.007-.18.017-.36.041-.539.068a.166.166,0,0,0-.041.007,28.48,28.48,0,1,1,22.853-17.07c-.176.343-.336.7-.479,1.059,0,0,0,.007,0,.007a12.605,12.605,0,0,0,7.824,16.591c.007,0,.014,0,.02.007.231.075.469.146.706.2a.047.047,0,0,0,.02.007A12.583,12.583,0,0,1,288.563,523.348Z",
    transform: "translate(-217.101 -453.787)",
    fill: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_8",
    "data-name": "Elipse 8",
    cx: 8.643,
    cy: 8.643,
    r: 8.643,
    transform: "translate(23.397 61.744)",
    fill: "#f9f9f9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_21",
    "data-name": "Grupo 21",
    transform: "translate(307.777 443.204)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_20",
    "data-name": "Grupo 20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_24",
    "data-name": "Caminho 24",
    d: "M451.922,488.628h23.845a1.008,1.008,0,0,1,1.008,1.008v6.671a1.008,1.008,0,0,1-1.008,1.008H461.746a1.009,1.009,0,0,0-1.008,1.009v6.537a1.008,1.008,0,0,0,1.008,1.008H474.5a1.009,1.009,0,0,1,1.008,1.009v6.537a1.008,1.008,0,0,1-1.008,1.008H461.746a1.009,1.009,0,0,0-1.008,1.009v12.284a1.009,1.009,0,0,1-1.009,1.008h-7.807a1.008,1.008,0,0,1-1.008-1.008V489.636A1.008,1.008,0,0,1,451.922,488.628Z",
    transform: "translate(-450.914 -488.628)",
    fill: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_25",
    "data-name": "Caminho 25",
    d: "M529.123,488.628h7.807a1.008,1.008,0,0,1,1.008,1.008V519.3a1.009,1.009,0,0,0,1.009,1.009h15.425a1.009,1.009,0,0,1,1.009,1.008v6.4a1.009,1.009,0,0,1-1.009,1.008H529.123a1.009,1.009,0,0,1-1.009-1.008V489.636A1.009,1.009,0,0,1,529.123,488.628Z",
    transform: "translate(-498.175 -488.628)",
    fill: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_26",
    "data-name": "Caminho 26",
    d: "M611.664,488.628h24.514a1.008,1.008,0,0,1,1.008,1.008v6.671a1.008,1.008,0,0,1-1.008,1.008h-14.69a1.009,1.009,0,0,0-1.008,1.009v5.2a1.008,1.008,0,0,0,1.008,1.008h13.42a1.009,1.009,0,0,1,1.008,1.009v6.537a1.008,1.008,0,0,1-1.008,1.008h-13.42a1.009,1.009,0,0,0-1.008,1.009v5.2a1.009,1.009,0,0,0,1.008,1.009h15.425a1.008,1.008,0,0,1,1.009,1.008v6.4a1.008,1.008,0,0,1-1.009,1.008H611.664a1.008,1.008,0,0,1-1.008-1.008V489.636A1.008,1.008,0,0,1,611.664,488.628Z",
    transform: "translate(-548.706 -488.628)",
    fill: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_27",
    "data-name": "Caminho 27",
    d: "M702.49,507.323,691.013,490.2a1.009,1.009,0,0,1,.838-1.57h8.982a1.007,1.007,0,0,1,.853.47l6.379,10.1a1.009,1.009,0,0,0,1.718-.021l6.015-10.062a1.009,1.009,0,0,1,.866-.491h8.881a1.008,1.008,0,0,1,.85,1.551l-11.419,17.875a1.008,1.008,0,0,0,.011,1.1l12.02,18a1.009,1.009,0,0,1-.839,1.569h-8.8a1.008,1.008,0,0,1-.843-.455L709.4,517.407a1.008,1.008,0,0,0-1.7.016l-6.82,10.831a1.008,1.008,0,0,1-.853.471h-8.816a1.009,1.009,0,0,1-.847-1.557l12.13-18.736A1.008,1.008,0,0,0,702.49,507.323Z",
    transform: "translate(-597.404 -488.628)",
    fill: "#f9f9f9"
  })), /*#__PURE__*/React.createElement("text", {
    id: "consulta",
    transform: "translate(0 52.658)",
    fill: "#f9f9f9",
    fontSize: 15,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "consulta"))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.23904fd4a8474b2da1e15a10e9de8fc5.svg";
export { ForwardRef as ReactComponent };